import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Avatar,
  Chip,
} from '@mui/material';
import { Lock, People, Settings, Assessment } from '@mui/icons-material';

const MembersAreaPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom color="primary">
        Members Area
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Welcome to the exclusive members area. Access premium tools and resources for community builders.
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6} lg={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1, textAlign: 'center', py: 4 }}>
              <Avatar sx={{ bgcolor: '#89479a', width: 64, height: 64, mx: 'auto', mb: 2 }}>
                <People />
              </Avatar>
              <Typography variant="h5" component="h2" gutterBottom>
                Team Management
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Manage your team members, track progress, and coordinate activities efficiently.
              </Typography>
              <Button variant="contained" color="primary" fullWidth>
                Manage Team
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1, textAlign: 'center', py: 4 }}>
              <Avatar sx={{ bgcolor: '#f78f29', width: 64, height: 64, mx: 'auto', mb: 2 }}>
                <Assessment />
              </Avatar>
              <Typography variant="h5" component="h2" gutterBottom>
                Analytics Dashboard
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                View detailed analytics, track performance metrics, and generate reports.
              </Typography>
              <Button variant="contained" color="primary" fullWidth>
                View Analytics
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1, textAlign: 'center', py: 4 }}>
              <Avatar sx={{ bgcolor: '#4caf50', width: 64, height: 64, mx: 'auto', mb: 2 }}>
                <Settings />
              </Avatar>
              <Typography variant="h5" component="h2" gutterBottom>
                Advanced Settings
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Configure advanced options, customize workflows, and manage preferences.
              </Typography>
              <Button variant="contained" color="primary" fullWidth>
                Configure Settings
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card sx={{ p: 4, textAlign: 'center' }}>
            <Avatar sx={{ bgcolor: '#89479a', width: 80, height: 80, mx: 'auto', mb: 2 }}>
              <Lock />
            </Avatar>
            <Typography variant="h4" component="h2" gutterBottom>
              Premium Features Coming Soon
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              We're working on exciting new features for our members. Stay tuned for advanced tools and exclusive content.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Chip label="Advanced Analytics" color="primary" variant="outlined" />
              <Chip label="Team Collaboration" color="primary" variant="outlined" />
              <Chip label="Custom Reports" color="primary" variant="outlined" />
              <Chip label="Priority Support" color="primary" variant="outlined" />
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MembersAreaPage;
